import { drop } from 'ramda';

import {
  REGISTER,
  LOGIN,
  PAYMENT,
  PREMIUM_OFFER,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  GIFT_BOOK,
  ACCOUNT_BOOK,
} from '../const';

export const getThanksForFlipBook = (wishPremium, orderOption) => ({
  form: {
    title: 'Your FlipBook is ready',
    ...(orderOption === GIFT_BOOK
      ? {
          description: 'Thank you for your order, check your inbox',
          button: { name: 'To the video studio', url: '/videos' },
        }
      : {
          textWithLinks: [
            { type: 'text', value: 'Thank you for your order. You can now find your new book under' },
            { type: 'link', name: 'My Fintool', url: '/meine-kurse/books' },
            { type: 'text', value: 'and in the' },
            { type: 'link', name: 'Fintool Academy', url: '/akademie' },
            { type: 'text', value: '.', withoutTranslation: true },
          ],
          button: { name: 'My Fintool', url: '/meine-kurse/books' },
        }),
  },
});
// bookIds: any order (premium id, basic id, basic and subscription id),
// prices: [premium price, basic price];
// products: [premium id, basic id, basic and subscription id];
// premiumOffer: subscription price
export const getFlipBookPurchases = (prices, products, premiumOffer) => [
  {
    id: 1,
    name: 'Fintool Premium Subscriber',
    tasks: {
      [LOGIN]: () => ({
        banner: {
          title: 'Fintool Premium Subscriber',
          price: prices[0] === prices[1] ? 'PriceCHF' : 'PriceCHF/insteadCHF',
          priceValues: prices,
          propositions: ['FlipBook'],
        },
        form: {
          showSubscribeDescription: false,
          inputs: [EMAIL, PASSWORD],
          submitButton: 'Login',
          showAdb: false,
        },
        nextStep: 1,
      }),
      [PAYMENT]: () => ({
        banner: {
          title: 'Fintool Premium Subscriber',
          price: prices[0] === prices[1] ? 'PriceCHF' : 'PriceCHF/insteadCHF',
          priceValues: prices,
          propositions: ['FlipBook'],
        },
        form: { withPromoCode: false, isFree: prices[0] === 0 },
        navigation: '1/1',
        nextStep: 2,
        shouldSignUp: false,
        subscribeId: null,
        productId: products[0],
      }),
      [THANKS]: getThanksForFlipBook,
    },
  },
  {
    id: 2,
    name: 'Fintool Basic subscriber',
    tasks: {
      [LOGIN]: () => ({
        banner: {
          title: 'Fintool Basic subscriber',
          price: 'PriceCHF',
          priceValues: drop(1, prices),
          propositions: ['FlipBook'],
        },
        form: {
          showSubscribeDescription: false,
          inputs: [EMAIL, PASSWORD],
          submitButton: 'Login',
          showAdb: false,
        },
        nextStep: 1,
      }),
      ...(typeof premiumOffer === 'number' && {
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [premiumOffer, premiumOffer + prices[1]],
            propositions: ['FlipBook', '12 months Fintool-Premium'],
          },
          form: {
            title: 'Switch to Fintool-Premium now and get the book for free',
            priceDescription: 'If you decide now on a Fintool premium annual subscription for',
            priceValues: [premiumOffer, prices[1]],
            yesButton: 'Yes, buy for',
            noButton: 'Continue without Premium',
          },
          navigation: '2/3',
          prevStep: 0,
          nextStep: 2,
        }),
      }),
      [PAYMENT]: (wishPremium) => ({
        banner: {
          title: wishPremium ? 'Fintool Premium Subscriber' : 'Fintool Basic subscriber',
          price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
          priceValues: wishPremium ? [premiumOffer, premiumOffer + prices[1]] : drop(1, prices),
          propositions: wishPremium ? ['FlipBook', '12 months Fintool-Premium'] : ['FlipBook'],
        },
        form: { withPromoCode: false, isFree: !wishPremium && prices[1] === 0 },
        navigation: typeof premiumOffer === 'number' ? '3/3' : '2/2',
        prevStep: typeof premiumOffer === 'number' ? 1 : 0,
        nextStep: typeof premiumOffer === 'number' ? 3 : 2,
        shouldSignUp: false,
        subscribeId: wishPremium ? 6 : null,
        productId: wishPremium ? products[2] : products[1],
      }),
      [THANKS]: getThanksForFlipBook,
    },
  },
  {
    id: 3,
    name: 'No subscription',
    tasks: {
      [REGISTER]: () => ({
        banner: {
          title: 'No subscription',
          price: 'PriceCHF',
          priceValues: drop(1, prices),
          propositions: ['FlipBook'],
        },
        form: {
          showSubscribeDescription: false,
          inputs: [FIRST_NAME, LAST_NAME, EMAIL, PASSWORD],
          submitButton: 'Register',
          showAdb: true,
        },
        navigation: typeof premiumOffer === 'number' ? '1/3' : '1/2',
        nextStep: 1,
      }),
      ...(typeof premiumOffer === 'number' && {
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [premiumOffer, premiumOffer + prices[1]],
            propositions: [
              'FlipBook',
              'Regularly new videos by e-mail',
              'Unlimited access to video library',
              'Access to the entire course offering',
              'Unlimited access to the forums',
              'Knowledge reviews',
              'No advertising breaks',
            ],
          },
          form: {
            title: 'Get Fintool Premium now and get the book for free',
            priceDescription: 'If you decide now on a Fintool premium annual subscription for',
            priceValues: [premiumOffer, prices[1]],
            yesButton: 'Yes, buy for',
            noButton: 'Order book only',
          },
          navigation: '2/3',
          prevStep: 0,
          nextStep: 2,
        }),
      }),
      [PAYMENT]: (wishPremium) => ({
        banner: {
          title: wishPremium ? 'Fintool Premium Subscriber' : 'Not a Fintool subscriber',
          price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
          priceValues: wishPremium ? [premiumOffer, premiumOffer + prices[1]] : drop(1, prices),
          propositions: wishPremium ? ['FlipBook', '12 months Fintool-Premium'] : ['FlipBook'],
        },
        form: { withPromoCode: false, isFree: !wishPremium && prices[1] === 0 },
        navigation: typeof premiumOffer === 'number' ? '3/3' : '2/2',
        prevStep: typeof premiumOffer === 'number' ? 1 : 0,
        nextStep: typeof premiumOffer === 'number' ? 3 : 2,
        shouldSignUp: true,
        subscribeId: wishPremium ? 6 : null,
        productId: wishPremium ? products[2] : products[1],
      }),
      [THANKS]: getThanksForFlipBook,
    },
  },
];

export const getThanksForMoneyCombo3 = (wishPremium, orderOption) => ({
  form:
    orderOption === ACCOUNT_BOOK
      ? {
          title: 'Your FlipBook is ready',
          textWithLinks: [
            { type: 'text', value: 'Thank you for your order. You can now find your new book under' },
            { type: 'link', name: 'My Fintool', url: '/meine-kurse/books' },
            { type: 'text', value: 'and in the' },
            { type: 'link', name: 'Fintool Academy', url: '/akademie' },
            { type: 'text', value: '.', withoutTranslation: true },
            { type: 'text', value: 'Take advantage of the Fintool Premium offer during the reading breaks' },
          ],
          button: { name: 'My Fintool', url: '/meine-kurse/books' },
        }
      : {
          title: 'Your order is on its way',
          description:
            'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
          button: { name: 'To the Fintool Academy', url: '/akademie' },
        },
});
